import { render, staticRenderFns } from "./Bairros.vue?vue&type=template&id=acb1dcc6&"
import script from "./Bairros.vue?vue&type=script&lang=js&"
export * from "./Bairros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports